import React, { useState, useMemo, useEffect, useRef } from "react";
import TagInput from "../../TagInput/TagInput.jsx";
import TextEditor from "../../TextEditor/TextEditor.jsx";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from 'react-i18next'
import { fr, enGB } from "date-fns/locale"
import { useSelector, useDispatch } from 'react-redux';
import spinnerImg from "../../../../../assets/spinner.gif";
import {
  fetchNonGuestUsersByMap, createConference
} from "../../../store/AddEvent/AddEventThunks.js";
import {
  updateConference
} from "../../../store/Conference/ConferenceThunks.js";
import {
  setNonGuestUsers,
  UPDATE_RESERVATION,
} from '../../../store/AddEvent/AddEventSlice.js';
import {
  getActiveInvites
} from "../../../store/Invite/inviteThunk.js";
import "./ConferenceEventForm.css";
import {
  setAccessType,
  setAllowAudio,
  setAllowCamera,
  setExternaInscreption,
  setAllowMessages,
  setAllowMic,
  setAllowReaction,
  setAllowScreenShare,
  setDate,
  setEmailConfirmationEnabled,
  setRegistrationLink,
  setInviteAllInternal,
  setMapId,
  setParticipants,
  setReminder5MinBefore,
  setReminderOnEventDay,
  setRoomId,
  setTitle,
  setDescription,
  setId,
  setInit,
  NEW_RESERVATION,
  loadReservation
} from "../../../store/Conference/CreateConferenceSlice.js";
import { setAnchorPosition } from "../../../../Map/store/MapDisplaySlice.js";
import { setOpenModal } from "../../../store/controlPanelSlice.js";

registerLocale("fr", fr);
registerLocale("en", enGB);

export default function ConferenceEventForm({ onClose }) {

  const roomRef = useRef(null);
  const initRef = useRef(false);
  const fileInputRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    tenant
  } = useSelector((state) => state.auth);

  const tenantId = tenant?.id;

  const {
    selectedRoom,
    roomsData,
    mapConfig
  } = useSelector((state) => state.MapDisplay);

  const {
    nonGuestUsers
  } = useSelector((state) => state.AddEvent);

  const {
    invitationList
  } = useSelector((state) => state.inviteModal);

  const {
    initialReservation,
    updateRoom
  } = useSelector((state) => state.RoomMenu);

  const {
    id,
    map_id,
    title,
    description,
    date,
    room_id,
    allow_mic,
    allow_camera,
    allow_screen_share,
    allow_audio,
    allow_reaction,
    allow_messages,
    invite_all_internal,
    ext_inscription,
    registration_link,
    access_type,
    email_confirmation_enabled,
    reminder_on_event_day,
    reminder_5_min_before,
    participants
  } = useSelector((state) => state.createConference);


  const { t } = useTranslation();
  const { preferredLanguage, localAvatar } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const creatRegestrationLink = (title) => {
    if (!updateRoom) {
      const slug = slugify(title || "conference");
      const code = `${slug}-${Date.now()}`;
      const link = `${window.location.origin}/conference/registration/${code}`;
      dispatch(setRegistrationLink(link));
    }
  }

  useEffect(() => {
    if (!updateRoom) {
      setSelectedConferenceRoom(selectedRoom);
      dispatch(setMapId(mapConfig.mapId));
      dispatch(setRoomId(selectedRoom));
      dispatch(setAllowMic(true));
      dispatch(setAllowCamera(true));
      dispatch(setAllowScreenShare(true));
      dispatch(setAllowAudio(true));
      dispatch(setAllowMessages(true));
      dispatch(setAllowReaction(true));
      dispatch(setAccessType("room"));
      dispatch(setEmailConfirmationEnabled(true));
      dispatch(setReminderOnEventDay(true));
      dispatch(setReminder5MinBefore(false));
      dispatch(setExternaInscreption(true));
      dispatch(setInviteAllInternal(false));
      dispatch(setParticipants([]));
      creatRegestrationLink(title);
    }
  }, []);

  const [error, setError] = useState();

  const [internalGuests, setInternalGuests] = useState([]);
  const [masters, setMasters] = useState([]);
  const [externalGuests, setExternalGuests] = useState([]);
  const [nonRemovableParticipants, setNonRemovableParticipants] = useState([]);
  const [sessionDate, setSessionDate] = useState(roundTo30Min(new Date()));
  const [showPicker, setShowPicker] = useState(false);
  const nowRounded = roundTo30Min(new Date());
  const maxTime = new Date();
  maxTime.setHours(23, 30, 0, 0);

  const originalParticipantsRef = useRef([]);
  const principalMasterEmailRef = useRef(null);

  useEffect(() => {
    const isoDate = sessionDate.toISOString();
    dispatch(setDate(isoDate));

  }, [sessionDate]);

  const [roomQuery, setRoomQuery] = useState("");
  const [selectedConferenceRoom, setSelectedConferenceRoom] = useState(null);
  const [showRoomList, setShowRoomList] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [oldRoomId, setOldRoomId] = useState(null);
  const rooms = useMemo(() => {
    return roomsData.filter(room =>
      room.label.toLowerCase().includes(roomQuery.toLowerCase())
    );
  }, [roomsData, roomQuery]);

  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(registration_link);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);

    } catch (err) {
      console.error("Erreur copie:", err);
    }
  };

  const [file, setFile] = useState();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (roomRef.current && !roomRef.current.contains(event.target)) {
        setShowRoomList(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const initializeComponent = async () => {
      try {
        const usersResp = await dispatch(
          fetchNonGuestUsersByMap({
            params: [{ mapId: mapConfig.mapId }]
          })
        ).unwrap();

        const users = Array.isArray(usersResp) ? usersResp : [];

        dispatch(setNonGuestUsers(users));
        dispatch(getActiveInvites());

        const uniqueByEmail = (arr) => {
          const map = new Map();
          arr.forEach(item => {
            if (!map.has(item.email)) {
              map.set(item.email, item);
            }
          });
          return Array.from(map.values());
        };



        if (initialReservation && updateRoom) {
          dispatch(loadReservation(initialReservation));
          setOldRoomId(initialReservation.room_tenant['room_id']);
          setSelectedConferenceRoom(
            {
              room_id: initialReservation.room_tenant['room_id'],
              label: initialReservation.room_tenant['label'],
              chair_count: initialReservation.room_tenant['chair_count']
            }
          )
          setSessionDate(new Date(initialReservation.date));

          const participants = initialReservation?.conferenceParticipants || [];
          const mastersList = [];
          const internalList = [];
          const externalList = [];
          let nonRemovables = [localAvatar.email?.toLowerCase()];

          participants.forEach(p => {
            const user =
              users.find(u => u.email === p.email);
            if (user) {
              const userData = {
                id: user.id,
                email: user.email,
                display_name: user.display_name,
                urlphoto: user.urlphoto
              };

              if (
                p.role === "master" ||
                p.role === "principal-master"
              ) {
                mastersList.push(userData);
                if (p.role === "principal-master") {
                  nonRemovables.push(p.email);
                  principalMasterEmailRef.current = p.email?.toLowerCase();
                }
              }

              else if (p.role === "guest") {
                internalList.push(userData);
              }

              else if (p.role === "guest_externe") {
                externalList.push(userData);
              }
            } else if (p.role === "guest_externe") {
              const userData = {
                id: p.id,
                email: p.email,
                display_name: p.user.display_name,
                urlphoto: p.user.urlphoto
              };

              externalList.push(userData);
            }
          });
          setMasters(uniqueByEmail(mastersList));
          setInternalGuests(uniqueByEmail(internalList));
          setExternalGuests(uniqueByEmail(externalList));
          setNonRemovableParticipants(nonRemovables);

          if (internalList.length > 0) {
            const access = initialReservation?.conferenceParticipants?.find(u => u.role === "guest")?.access_type;
            dispatch(setAccessType(access))
          }

          const originalParticipants = [];


          mastersList.forEach(u => {
            const originalP = participants.find(p => p.email === u.email);
            originalParticipants.push({
              email: u.email.toLowerCase(),
              role: originalP?.role || "master",
              id: originalP?.id  
            });
          });

          internalList.forEach(u => {
            const originalP = participants.find(p => p.email === u.email);
            originalParticipants.push({
              email: u.email.toLowerCase(),
              role: "guest",
              id: originalP?.id 
            });
          });

          externalList.forEach(u => {
            const originalP = participants.find(p => p.email === u.email);
            originalParticipants.push({
              email: u.email.toLowerCase(),
              role: "guest_externe",
              id: originalP?.id 
            });
          });

          originalParticipantsRef.current = originalParticipants;

        }

      }


      catch (error) {

        console.error(
          "Erreur init edit event:",
          error
        );

      }

    };


    if (!initRef.current) {

      initRef.current = true;

      initializeComponent();

    }

  }, []);

  const [showEditor, setShowEditor] = useState(false);


  const handleAccessChange = (value) => {
    dispatch(setAccessType(value));
  };

  useEffect(() => {
    creatRegestrationLink(title);
  }, [title]);


  useEffect(() => {
    const guestsSource = invite_all_internal ? nonGuestUsers : internalGuests;

    const participants = [
      ...guestsSource.map(item => ({
        email: item.email,
        role: "guest",
        access_type: access_type
      })),

      ...(ext_inscription
        ? externalGuests?.map(item => ({
          email: item.email,
          role: "guest_externe",
          access_type: access_type
        }))
        : []),

      ...masters.map(item => ({
        email: item.email,
        role: "master",
        access_type: access_type
      }))
    ];

    dispatch(setParticipants(participants));



  }, [internalGuests, externalGuests, masters, access_type, ext_inscription, invite_all_internal]);

  useEffect(() => {
    dispatch(setRoomId(selectedConferenceRoom?.room_id));
  }, [selectedConferenceRoom]);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFile(file);
  };


  const handleCancel = () => {
    onClose();
  }

  const computeParticipantDeltas = (oldParticipants, newParticipants, currentUserEmail, principalMasterEmail) => {

    const filteredOld = oldParticipants.filter(p =>
      p.email?.toLowerCase() !== principalMasterEmail?.toLowerCase()
    );

    const filteredNew = newParticipants.filter(p =>
      p.email?.toLowerCase() !== principalMasterEmail?.toLowerCase()
    );

    const oldMap = new Map(filteredOld.map(p => [p.email?.toLowerCase(), p]));
    const newMap = new Map(filteredNew.map(p => [p.email?.toLowerCase(), p]));

    const toAdd = [];
    const toDelete = [];
    const toUpdate = [];

    filteredNew.forEach(newP => {
      const email = newP.email?.toLowerCase();
      const oldP = oldMap.get(email);

      if (!oldP) {
        toAdd.push({ email: newP.email, role: newP.role });
      } else if (oldP.role !== newP.role) {
        if (oldP.id) {
          toUpdate.push({ id: oldP.id, role: newP.role });
        }
      }
    });

    filteredOld.forEach(oldP => {
      const email = oldP.email?.toLowerCase();
      const newP = newMap.get(email);

      if (email === currentUserEmail?.toLowerCase()) return;
      if (email === principalMasterEmail?.toLowerCase()) return; // 🎯 Extra safety

      if (!newP && oldP.id) {
        toDelete.push(oldP.id);
      }
    });

    return { toAdd, toDelete, toUpdate };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);

    if (!title?.trim()) {
      setError(t("TITLE_IS_REQUIRED"));
      return;
    }

    if (!date?.trim()) {
      setError(t("DATE_IS_REQUIRED"));
      return;
    }

    if (!room_id) {
      setError(t("ROOM_IS_REQUIRED"));
      return;
    }
    /* if (selectedConferenceRoom?.chair_count < participants.length) {
      setError(`La capacité de la salle est dépassée. Capacité maximale : ${selectedConferenceRoom?.chair_count} personnes.`);
      return;
    } */
    let payload = {}
    if (updateRoom) {
      const guestsSource = invite_all_internal ? nonGuestUsers : internalGuests;
      const currentParticipants = [
        ...guestsSource.map(item => ({ email: item.email, role: "guest", access_type })),
        ...(ext_inscription ? externalGuests?.map(item => ({ email: item.email, role: "guest_externe", access_type })) : []),
        ...masters.map(item => ({ email: item.email, role: "master", access_type }))
      ];

      const { toAdd, toDelete, toUpdate } = computeParticipantDeltas(
        originalParticipantsRef.current,
        currentParticipants,
        localAvatar.email,
        principalMasterEmailRef.current
      );

      payload = {
        title,
        description,
        date,
        map_id,
        room_id,
        allow_audio,
        allow_camera,
        allow_messages,
        allow_mic,
        allow_reaction,
        allow_screen_share,
        invite_all_internal,
        ext_inscription,
        registration_link,
        ConferenceParticipantToAdd: toAdd,
        ConferenceParticipantToDelete: toDelete,
        ConferenceParticipantToUpdate: toUpdate,
        email_confirmation_enabled,
        reminder_on_event_day,
        reminder_5_min_before,
        type: "conference",
        owner_email: localAvatar.email
      };

    }
    else {
      payload = {
        title,
        description,
        date,
        map_id,
        room_id,
        allow_audio,
        allow_camera,
        allow_messages,
        allow_mic,
        allow_reaction,
        allow_screen_share,
        invite_all_internal,
        ext_inscription,
        registration_link,
        participants,
        email_confirmation_enabled,
        reminder_on_event_day,
        reminder_5_min_before,
        type: "conference",
        owner_email: localAvatar.email
      };

    }

    const formData = new FormData();
    if (file) {
      formData.append("file", file);
    }

    try {
      if (updateRoom) {
        formData.append(
          "updatedData",
          JSON.stringify(payload)
        );

        const response = await dispatch(
          updateConference({
            params: [{ ConferenceId: id }],
            body: formData
          })
        );
        if (response) {
          dispatch(UPDATE_RESERVATION({ new_room_id : room_id , old_room_id: oldRoomId, isReserved: true, tenantId, refreshAll: true, }));
          dispatch(setAnchorPosition(null));
          dispatch(setOpenModal(null));
        }
        if (!response.error) {
          onClose();
        }
      } else {
        formData.append(
          "bookingData",
          JSON.stringify(payload)
        );
        const response = await dispatch(
          createConference({ body: formData })
        );
        if (response) {
          dispatch(NEW_RESERVATION({ room_id: selectedRoom.room_id, isReserved: true, tenantId, refreshAll: true, }));
          dispatch(setAnchorPosition(null));
          dispatch(setOpenModal(null));
        }
        if (!response.error) {
          onClose();
        }
      }

    } catch (error) {
      console.error("error", error);
    } finally {
      setIsSubmitting(false); 
    }
  };

  return (
    <>

      <div className="conference-form">
        {/* titre */}
        <div className="field-container">
          <label>Titre de l'événement <span className="required-field">*</span></label>
          <input
            type="text"
            className="input"
            placeholder="Saisir le nom de l'événement"
            value={title}
            onChange={(e) => dispatch(setTitle(e.target.value))}
          />
        </div>

        {/* description */}
        <div className="field-container">
          <div className="description-header">
            <label>Description (Optionnel)</label>

            <button className="advanced-btn" type="button" onClick={() => setShowEditor(true)}>
              <span className="material-symbols-outlined">edit</span>
              Edition avancée
            </button>
          </div>

          <textarea
            placeholder="Aucune description- cliquez sur 'Édition avancée' pour en rédiger une."
            value={description}
            onChange={(e) =>
              dispatch(setDescription(e.target.value))
            }
          />
        </div>

        {/* session */}
        <div className="field-container">
          <label>Sessions programmées <span className="required-field">*</span></label>
          <input 
            type="text"
            value={formatSessionDate(sessionDate, t.language)}
            readOnly
            onClick={() => setShowPicker(true)} />
        </div>

        {/* salle */}
        <div className="field-container">
          <label>Salle Aifel <span className="required-field">*</span></label>

          <div className="room-input" ref={roomRef}>
            <input
              type="text"
              value={selectedConferenceRoom ? selectedConferenceRoom.label : roomQuery}
              placeholder="Salle Aifel"
              onFocus={() => setShowRoomList(true)}
              onChange={(e) => {
                setRoomQuery(e.target.value);
                setSelectedConferenceRoom(null);
                setShowRoomList(true);
              }}
            />

            <div className="room-icons">
              <span className="selected-salle-count">{selectedConferenceRoom?.chair_count}</span>
              <span className="material-symbols-outlined person">
                person
              </span>
              <span className="material-symbols-outlined search">search</span>
            </div>
            {showRoomList && rooms.length > 0 && (

              <div className="room-suggestions">

                {rooms.map((room, index) => (

                  <div
                    key={room.room_id}
                    className={`room-item ${index === activeIndex ? "active" : ""}`}
                    onMouseEnter={() => setActiveIndex(index)}
                    onClick={() => {
                      setSelectedConferenceRoom(room);
                      setRoomQuery(room.label);
                      setShowRoomList(false);
                      setActiveIndex(-1);
                    }}
                  >

                    <span className="room-label">{room.label}</span>
                    <span className="room-chairs">
                      {room?.chair_count}
                      <span className="material-symbols-outlined">
                        person
                      </span>
                    </span>

                  </div>

                ))}

              </div>

            )}
          </div>
        </div>

        {/* règles */}
        <div className="rules-box grey-box-form">

          <div className="rules-header">
            <span className="material-symbols-outlined green">settings</span>

            <div>
              <b>Règles par défaut</b>
              <p>Appliqué à l'ouverture de la conférence pour les participants</p>
            </div>
          </div>

          <div className="rules-grid">

            <Rule label="Autorisation micro" icon="mic" value={allow_mic} onChange={() => dispatch(setAllowMic(!allow_mic))} />

            <Rule label="Autorisation camera" icon="videocam" value={allow_camera} onChange={() => dispatch(setAllowCamera(!allow_camera))} />

            <Rule label="Autorisation partage écran" icon="screen_share" value={allow_screen_share} onChange={() => dispatch(setAllowScreenShare(!allow_screen_share))} />

            <Rule label="Autorisation réactions" icon="sentiment_satisfied" value={allow_reaction} onChange={() => dispatch(setAllowReaction(!allow_reaction))} />

            <Rule label="Son entrée et sortie de la salle" icon="volume_up" value={allow_audio} onChange={() => dispatch(setAllowAudio(!allow_audio))} />

            <Rule label="Autorisation messagerie" icon="forum" value={allow_messages} onChange={() => dispatch(setAllowMessages(!allow_messages))} />

          </div>

        </div>

        {/* participants */}
        <div className="participants-box grey-box-form">

          <div className="participants-header">
            <span className="material-symbols-outlined green">group</span>

            <div>
              <b>Les participants</b>
              <p>Choisir les participants internes</p>
            </div>
          </div>

          <label>Participants</label>

          <div className="tags">
            <TagInput
              users={nonGuestUsers.length > 0 ? nonGuestUsers : []}
              value={internalGuests}
              onChange={setInternalGuests}
              placeholder="Ajouter des participants"
              nonRemovableEmails={nonRemovableParticipants}
            />
          </div>

          <label className="checkbox-line">
            <input type="checkbox" onChange={() => dispatch(setInviteAllInternal(!invite_all_internal))} />
            Invité tous les utilisateurs internes
          </label>

          <label>Masters</label>

          <div className="tags">
            <TagInput
              users={nonGuestUsers.length > 0 ? nonGuestUsers : []}
              value={masters}
              onChange={setMasters}
              placeholder="Ajouter des participants"
              nonRemovableEmails={nonRemovableParticipants}
            />
          </div>

        </div>

        <div className="external-box grey-box-form">
          <div className="external-header">
            <span className="material-symbols-outlined green">link</span>
            <div>
              <b>Inscription externe</b>
              <p>Permettre à des invités externes de s'inscrire</p>
            </div>

            <label className="switch">
              <input
                type="checkbox"
                checked={ext_inscription}
                onChange={(e) =>
                  dispatch(setExternaInscreption(e.target.checked))
                }
              />
              <span className="slider"></span>
            </label>

          </div>

          {ext_inscription && (
            <>

              <div className="access-buttons">
                <span className="label-access">Accès Aifel</span>

                <div className="access-buttons-container">
                  <button
                    type="button"
                    className={`btn-access ${access_type === "map" ? "selected-access" : ""}`}
                    onClick={() => handleAccessChange("map")}
                  >
                    Accès bureau virtuel
                  </button>

                  <button
                    type="button"
                    className={`btn-access ${access_type === "room" ? "selected-access" : ""}`}
                    onClick={() => handleAccessChange("room")}
                  >
                    Seulement à la salle
                  </button>
                </div>
              </div>

              <label>Lien d'inscription</label>

              <div className="link-input">
                <input
                  value={registration_link}
                  readOnly
                />

                <span
                  className={`material-symbols-outlined copy-icon ${copied ? "copied" : ""}`}
                  onClick={handleCopy}
                >
                  {copied ? "check" : "content_copy"}
                </span>
              </div>

              <label>Participants</label>

              <div className="tags">
                <TagInput
                  users={invitationList.length > 0 ? invitationList.map(i => { return i.user_map }) : []}
                  value={externalGuests}
                  onChange={setExternalGuests}
                  placeholder="Ajouter des participants"
                  allowCustomEmail={true}
                />
              </div>

              <label className="checkbox-line">
                <input type="checkbox" defaultChecked />
                Rappel à tous les participants externes
              </label>

              <hr />

              <div className="email-box">

                <div className="email-header">
                  <span className="material-symbols-outlined">mail</span>
                  <b>Paramètres emails</b>
                </div>

                <Rule
                  label="Email de confirmation"
                  value={email_confirmation_enabled}
                  onChange={() => dispatch(setEmailConfirmationEnabled(!email_confirmation_enabled))}
                />

                <Rule
                  label="Relance le jour J"
                  value={reminder_on_event_day}
                  onChange={() => dispatch(setReminderOnEventDay(!reminder_on_event_day))}
                />

                <Rule
                  label="Relance 5 minutes avant"
                  value={reminder_5_min_before}
                  onChange={() => dispatch(setReminder5MinBefore(!reminder_5_min_before))}
                />

              </div>

            </>
          )}

        </div>


        {/* Add image */}

        <div className="conferance-image">
          <label>Description (Optionnel)</label>
          <div
            className="conferance-image-container"
            onClick={handleImageClick}
            style={{
              backgroundImage: file
                ? `url(${URL.createObjectURL(file)})`
                : initialReservation?.photo
                  ? `url(${initialReservation.photo})`
                  : "none",
              backgroundSize: "cover",
              backgroundPosition: "center center",
            }}
          >
            {!file &&
              <>
                <span class="material-symbols-outlined">
                  download
                </span>
                <span className="conferance-image-label">Cliquez pour ajouter une photo</span>
              </>
            }
          </div>

          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>

        <div className="conference-form-action">
          <button type="button" className="cancel-form" onClick={handleCancel}>
            Annuler
          </button>
          <button type="button" className="validation-form" onClick={handleSubmit} disabled={isSubmitting} >
            {isSubmitting && <span className="create-conf-spinner">
              <img src={spinnerImg} />
            </span>
            }
            {updateRoom ? t("UPDATE_CONFERENCE") : t("CREATE_CONFERENCE")}
          </button>
        </div>

      </div>

      {showEditor && (
        <TextEditor
          value={description}
          onClose={() => setShowEditor(false)}
          onSave={(content) =>
            dispatch(setDescription(content))
          }
        />
      )}

      {showPicker && (
        <div className="datepicker-modal">
          <div className="datepicker-container">
            <span className="close-datepicker" onClick={() => setShowPicker(false)}>
              <span className="material-symbols-outlined">
                close
              </span>
            </span>
            <DatePicker
              selected={sessionDate}
              onChange={(date) => {
                const rounded = roundTo30Min(date);
                setSessionDate(rounded);
                setShowPicker(false);
              }}

              locale={preferredLanguage}
              showTimeSelect
              timeIntervals={30}
              dateFormat="Pp"

              minDate={new Date()}
              minTime={nowRounded}
              maxTime={maxTime}

              inline
            />

          </div>

        </div>
      )}
    </>
  );
}

function formatSessionDate(date, locale = "fr-FR") {

  const day = new Intl.DateTimeFormat(locale, {
    weekday: "long"
  }).format(date);

  const dayNumber = new Intl.DateTimeFormat(locale, {
    day: "numeric"
  }).format(date);

  const month = new Intl.DateTimeFormat(locale, {
    month: "short"
  }).format(date);

  const year = new Intl.DateTimeFormat(locale, {
    year: "numeric"
  }).format(date);

  const time = new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  }).format(date);

  const capitalize = (s) =>
    s.charAt(0).toUpperCase() + s.slice(1);

  return `${capitalize(day)}, ${dayNumber} ${month}.${year} - ${time.replace(":", "h")}`;
}

function roundTo30Min(date) {
  const ms = 1000 * 60 * 30;
  return new Date(Math.ceil(date.getTime() / ms) * ms);
}

function Rule({ label, icon, value, onChange }) {
  return (
    <div className="rule">

      <span class="material-symbols-outlined">
        {icon}
      </span>

      <span className="rule-label">{label}</span>

      <label className="switch">
        <input type="checkbox" checked={value} onChange={onChange} />
        <span className="slider"></span>
      </label>
    </div>
  );
}

function slugify(text) {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]/g, "-")
    .replace(/-+/g, "-");
}

function formatUserData(users) {
  return users?.map(user => ({
    id: user?.id,
    ...(user?.user || {})
  }));
}